const selectFollowUps = (state) => state.followUpDestinoBaixa.list || [];
const selectStatus = (state) => state.followUpDestinoBaixa.status;

const followUpDestinoBaixaSelectors = {
  selectFollowUps,
  selectStatus,
};

export default followUpDestinoBaixaSelectors;
